import React from "react";

import { IconButton, Tooltip } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import { FiMic, FiMicOff } from "react-icons/fi";

import useLocalAudioToggle from "../../hooks/useLocalAudioToggle/useLocalAudioToggle";

const useStyles = makeStyles(() =>
  createStyles({
    iconPointer: {
      cursor: "pointer",
    },
    iconButton: {
      padding: 0,
      marginLeft: "0.7rem",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&:disabled": {
        opacity: 0.8,
      },
    },
  })
);

export default function ToggleAudioButton(props: { disabled?: boolean }) {
  const [isAudioEnabled, toggleAudioEnabled] = useLocalAudioToggle();

  const { t: translate } = useTranslation();

  const classes = useStyles();

  let tooltipMessage = "";

  if (isAudioEnabled) {
    tooltipMessage = translate("disableMicrophone");
  }

  if (!isAudioEnabled) {
    tooltipMessage = translate("enableMicrophone");
  }

  const renderIcons = () => {
    if (isAudioEnabled)
      return (
        <FiMic
          size={18}
          color="#475467"
          className={classes.iconPointer}
          data-cy="videoSurveyEnabledAudioIcon"
        />
      );

    return (
      <FiMicOff
        size={18}
        color="#475467"
        className={classes.iconPointer}
        data-cy="videoSurveyDisabledAudioIcon"
      />
    );
  };

  return (
    <Tooltip title={tooltipMessage}>
      <span>
        <IconButton
          onClick={toggleAudioEnabled}
          disabled={props.disabled}
          data-cy="videoSurveyToggleAudioIcon"
          data-cy-audio-toggle
          className={classes.iconButton}
        >
          {renderIcons()}
        </IconButton>
      </span>
    </Tooltip>
  );
}
